import { Input, Table, Checkbox, Button, Spin, Divider, message } from "antd";
import React, { useEffect, useState } from "react";
import { BasicHeader } from "../../components/basic_header";
import ErrorWrapper from "../../lib/error_wrapper";
import moment from "moment";
import RefillForm from "./edit_refil_form";
import CustomDateRangePicker from "../../components/custom_date_range";
import { CustomButton, TransparentButton } from "../../components/basic_items";
import { withDomains, RESTExecutor } from "../../lib/domain";
import { defaultDateFormat, formatMoney, showErrorInNotification } from "../../lib/util";
import ConfigRefill from "./refill_config_form";
import { PopUpForm } from "../../lib/ui/popupform";



const addEditSchema=[
    {
        name:"EJ B64 ID",
        index:"ej_b64_id",
        type:"text"
    },
    {
        name:"Ledger B64 ID",
        index:"ledger_b64_id",
        type:"text"
    },
    {
        name:"Ledger CB",
        index:"ledger_cb",
        type:"number"
    },
    {
        name:"EJ CB",
        index:"ej_cb",
        type:"number"
    },
    {
        name:"EJ Refill",
        index:"ej_refill",
        type:"number"
    },
    {
        name:"Ledger Refill",
        index:"ledger_refill",
        type:"number"
    },
    {
        name:"Trace No",
        index:"trace_no",
        type:"text"
    },
    {
        name:"EJ Source ID",
        index:"ej_source_id",
        type:"text"
    },
    {
        name:"Refill Date",
        index:'refill_date',
        type:'date'
    }
]
const RefillTable = (props) => {
    // const [tableData, setTableData] = useState();
    const [selectedItems, setSelectedItems] = useState([]);
    const [isuploadModalVisible,setIsuploadModalVisible]=useState(false);
    const [isAddEditModalVisible,setIsAddEditModalVisible]=useState(false);
    const [selectedRecordId,setSelectedRecordId]=useState(null);
    const [formData,setFormData]=useState({});
    // const [isLoading, setIsLoading] = useState(true);
    const [reFilldata,setRefillData] = useState({})
    const [filterQuery, setFilterQuery] = useState({
        per_page: 100,
        page: 1,
    });
    const [visible, setVisible] = useState(false)
    const showModal = () => {
        setVisible(true);
    }
    const refillTableListExecutor = RESTExecutor.list()
        .config({
            label: "refill_table_list",
            params: {
                ...filterQuery,
            },
        })
        .callbacks(
            (success) => {
                // let rowsData = success.result || [];
                // let filteredData = JSON.parse(JSON.stringify(rowsData));
                // setTableData(filteredData);
                // setIsLoading(false);
            },
            (error) => {
                console.log(error);
            }
        )
        .connect(props.domains.activity);


    const postDataExecutor=RESTExecutor.post().config({
        label:'refill_table_list'
    }).callbacks((success)=>{
        setIsAddEditModalVisible(false);
        setFormData({});
        setSelectedRecordId(null);
        refillTableListExecutor.execute();
    },(error)=>{

    }).connect(props.domains.activity);

    const patchDataExecutor=RESTExecutor.patch().config({
        label:'refill_table_detail'
    }).callbacks((success)=>{
        refillTableListExecutor.execute();
        setIsAddEditModalVisible(false);
        setFormData({});
        setSelectedRecordId(null);
    },(error)=>{

    }).connect(props.domains.activity);


    const fileUploadExecutor=RESTExecutor.post()
    .config({
      label: "atm_refill_file",
    })
    .callbacks((success) => {
        setIsuploadModalVisible(false);
        message.success("Reversal Uploaded");
    },(error)=>{})
    .connect(props.domains.activity);

    useEffect(() => {
        refillTableListExecutor.execute();
    }, []);

    const deleteExecutor = RESTExecutor.post()
        .config({ label: "atm_refill_delete" })
        .callbacks((success)=>{
            setSelectedItems([])
            setFilterQuery({
                ...filterQuery,
                page:1
            })
            setTimeout(() => {
                refillTableListExecutor.config({
                    params:{
                        ...filterQuery,
                        page:1
                    }
                }).execute();
            }, 1000);
        },(error)=>{
            showErrorInNotification(error);
        })
        .connect(props.domains.activity)

    const handleSelectedItem = (itemID) => {
        const selected = selectedItems.includes(itemID);
        if (selected) {
            setSelectedItems(selectedItems.filter((id) => id !== itemID));
        } else {
            setSelectedItems([...selectedItems, itemID]);
        }
    };

    const handleQueryChange = (event) => {
        const { name, value } = event.target;
        if (value.trim() !== "") {
            setFilterQuery((prevQueryData) => ({
                ...prevQueryData,
                [name]: value,
            }));
        } else {
            setFilterQuery((prevQueryData) => ({
                ...prevQueryData,
                [name]: undefined,
            }));
        }
    };

    const handleDateRangeChange = (dates) => {
        setFilterQuery({
            ...filterQuery,
            date_from: dates.startDate.format(defaultDateFormat),
            date_to: dates.endDate.format(defaultDateFormat),
        });
    };

    const handleClearQuery = () => {
        setFilterQuery({
            ...filterQuery,
            date_from: null,
            date_to: null,
            ej_source_id: null,
            trace_no: null,
        })
    }

    const handleDelete = () => {
        deleteExecutor.execute({ id_list: selectedItems })
    };

    const fileUploadExecutorResponse=fileUploadExecutor.response();
    const refillTableListExecutorResponse =refillTableListExecutor.response();
    const deleteExecutorResponse = deleteExecutor.response();
    const rowsData=refillTableListExecutorResponse.result??[];
    const  rowsMeta=refillTableListExecutorResponse.meta??{};
    const postDataExecutorResponse=postDataExecutor.response();
    const patchDataExecutorResponse=patchDataExecutor.response();

    return (
        <div>
        <PopUpForm
          title={`Refill Table Upload`}
          stringyfy={false}
          show_title_only
          forCreate={true}
          initialData={{}}
          fields={[
            { index: "file", name: "File", type: "file" },
          ]}
          open={isuploadModalVisible}
          networkState={fileUploadExecutorResponse}
          onClose={() =>setIsuploadModalVisible(false)
          }
          onSubmit={(data) => {
            console.log("DATA", data);
            if (!data.file) {
              message.warn("Cannot upload empty data...");
              return;
            } else {
              let _formdata = new FormData();
              Object.keys(data).map((key) => {
                _formdata.append(key, data[key]);
              });
              // message.warn("END POINT NOT MADE")
              fileUploadExecutor
                .execute(_formdata);
            }
            // this.handlePostPatch(data);
          }}
        />
            <BasicHeader no_back title="Refill Table" menu_items={[]} right={[
                <TransparentButton
                label="Add New"
                className="cta-primary"
                hint="Add New Refill Data"
                onClick={() => {setIsAddEditModalVisible(true)}}
              />,
                 <TransparentButton
                 loading={fileUploadExecutorResponse.fetching}
                 disabled={fileUploadExecutorResponse.fetching}
                 label="Upload"
                 className="cta-primary"
                 hint="Upload"
                 onClick={() => {setIsuploadModalVisible(true)}}
               />
            ]} />
            <div className="filter-card" style={{ display: "flex", alignItems: "center", gap: "16px" }}>
                <div style={{ width: "33%" }}>
                    <Input.Search
                        placeholder="Terminal ID"
                        name="ej_source_id"
                        value={filterQuery.ej_source_id}
                        onChange={handleQueryChange}
                    />
                </div>
                <div style={{ width: "33%" }}>
                    <CustomDateRangePicker
                        excludeRanges
                        startDate={
                            filterQuery.date_from
                                ? moment(filterQuery.date_from, defaultDateFormat)
                                : null
                        }
                        endDate={
                            filterQuery.date_to
                                ? moment(filterQuery.date_to, defaultDateFormat)
                                : null
                        }
                        onChange={handleDateRangeChange}

                    />
                </div>
                <div style={{ width: "33%" }}>
                    <Input.Search
                        placeholder="Trace No"
                        name="trace_no"
                        value={filterQuery.trace_no}
                        onChange={handleQueryChange}
                    />
                </div>

                <CustomButton
                    className="primary-btn"
                    onClick={() => {
                        refillTableListExecutor
                            .config({
                                params: {
                                    ...filterQuery,
                                },
                            })
                            .execute();
                    }}
                    label="Filter" />

                <CustomButton
                    className="danger-btn"
                    onClick={() => {
                        handleClearQuery()
                        refillTableListExecutor.config({
                            params: {
                                per_page: 100,
                                page: 1
                            }
                        }).execute()
                    }}
                    label="Clear All" />
                <Divider type="vertical" />

                <ConfigRefill />
                <Button 
                loading={deleteExecutorResponse.fetching}
                type="danger" onClick={handleDelete}>
                    <strong>Delete Selected</strong>
                </Button>
            </div>

            <PopUpForm
                                            title={selectedRecordId?"Edit Refill Data":"Add Refill Data"}
                                            width="60%"
                                            forCreate={!selectedRecordId}
                                            initialData={formData}
                                            fields={addEditSchema}
                                            open={isAddEditModalVisible}
                                            networkState={selectedRecordId
                                                ? patchDataExecutorResponse
                                                : postDataExecutorResponse}
                                            onClose={() => {
                                                setFormData({});
                                                setIsAddEditModalVisible(false);
                                                setSelectedRecordId(null);
                                            }}
                                            onSubmit={(data) => {
                                                if(selectedRecordId){
                                                    patchDataExecutor.forId(selectedRecordId).execute(data)
                                                }else{
                                                    postDataExecutor.execute(data);
                                                }
                                            }} />
            <ErrorWrapper error={refillTableListExecutorResponse} onReload={()=>{
                refillTableListExecutor.execute();
            }}>
                
                    <div className="default-card" style={{ padding: 8 }}>
                        <Table
                            scroll={{ x: true }}
                            className="main-table"
                            size="small"
                            loading={refillTableListExecutorResponse.fetching||deleteExecutorResponse.fetching}
                            pagination={{
                                simple: false,
                                position: 'bottom',
                                onChange: (current, size) => {
                                    setFilterQuery({
                                        ...filterQuery,
                                        page:current,
                                        per_page:size
                                    })
                                    refillTableListExecutor
                                    .config({
                                        params: {
                                            ...filterQuery,
                                            page:current,
                                            per_page:size
                                        },
                                    })
                                    .execute();
                                    // this.props.history.push({
                                    //     search: queryString.stringify({ ...this.state.filter_query, per_page: size, page: current })
                                    // })
                                },
                                defaultCurrent: 1,
                                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                pageSize: (rowsMeta && rowsMeta.requested_count),
                                total: (rowsMeta && rowsMeta.total_count),
                                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                            }}
                            columns={[
                                {
                                    title: "",
                                    dataIndex: "id",
                                    key: "id",
                                    render: (id) => {
                                        return (
                                            <Checkbox
                                                checked={selectedItems.includes(id)}
                                                onChange={() => handleSelectedItem(id)}
                                            />
                                        );
                                    },
                                },
                                {
                                    title: "Terminal ID",
                                    dataIndex: "ej_source_id",
                                    key: "ej_source_id",
                                },
                                { title: "Refill Date", dataIndex: "refill_date", key: "refill_date" },
                                { title: "EJ ID", dataIndex: "ej_id", key: "ej_id" },
                                { title: "EJ Balance", dataIndex: "ej_cb", key: "ej_cb" },
                                {
                                    title: "EJ Refill Amount",
                                    dataIndex: "ej_refill",
                                    key: "ej_refill",
                                },
                                {
                                    title: "EJ Date",
                                    dataIndex: "ej_date",
                                    key: "ej_date",
                                },
                                {
                                    title: "Ledger Date",
                                    dataIndex: "ledger_date",
                                    key: "ledger_date",
                                },
                                {
                                    title: "Ledger ID",
                                    dataIndex: "ledger_id",
                                    key: "ledger_id",
                                },
                                {
                                    title: "Ledger Balance",
                                    dataIndex: "ledger_cb",
                                    key: "ledger_cb",
                                },
                                {
                                    title: "Ledger Refill Amount",
                                    dataIndex: "ledger_refill",
                                    key: "ledger_refill",
                                },
                                { title: "Trace No", dataIndex: "trace_no", key: "trace_no" },
                                {
                                    title: "",
                                    dataIndex: "id",
                                    key: "action",
                                    render: (id, data) => {
                                        return (
                                            <div style={{ display: "flex" }} >
                                                <Button type="link" onClick={()=> {
                                                    setIsAddEditModalVisible(true);
                                                    setSelectedRecordId(data.id)
                                                    setFormData(data);
                                                }
                                                }>Edit</Button>
                                            </div>
                                        );
                                    },
                                },
                            ]}
                            dataSource={rowsData}
                        />
                    </div>
            </ErrorWrapper>
            {/* {visible && <RefillForm refill_data={reFilldata} loader={setIsLoading} refill={atm_refill} visible={visible} setVisible={(e) => setVisible(e)}/>} */}

        </div>
    );
};

export default withDomains(RefillTable, "activity");
